import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IQuestionReportElement} from '../../../../../incase-domain/elements/question/questionReportElement';
import {useSlidePreviewCapture} from '../../../../../context/SlidePreviewCaptureContext';
import QuestionReportPreview from './QuestionReportPreview';
import QuestionReportLive from './QuestionReportLive';

interface QuestionReportElementProps {
    element: IQuestionReportElement;
    device: DeviceType;
}

function QuestionReportElement({element, device}: QuestionReportElementProps): ReactElement {
    const isSlidePreviewCapture = useSlidePreviewCapture();

    if (isSlidePreviewCapture) {
        return <QuestionReportPreview element={element} device={device} />;
    }

    return <QuestionReportLive element={element} device={device} />;
}

export default QuestionReportElement;
